import type { UseLoginWithEmailBody, PromotionData } from '#types'

export const useReactivateUser = () => {
    const data = useState<(UseLoginWithEmailBody & { first_name: string, channel: 'signup' | 'login', email: string, password?: string, promotionId?: string, promotionAccepted?: boolean } & PromotionData) | undefined>('auth:reactivate-user', () => {
        return undefined
    })

    return {
        data,
    }
}
